import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/all-calculators/page.tsx");
